import React from 'react';
import PropTypes from 'prop-types';
import { i18next } from '@yola/ws-sdk';
import { designSystem } from '@yola/ws-ui';
import utils from 'src/js/modules/utils';
import helpers from '../helpers';
import constants from '../constants';

const {
  Stack,
  ControlGroup,
  InputGroupField,
  SimpleSelectField,
  RadioButtonGroupField,
  CheckboxField,
} = designSystem;

const { createRequiredValidator } = utils.validators;
const {
  common: { LABEL_INPUT, BUTTON_TEXT_INPUT },
  fieldControlNames,
  numberOfFilesAttachment,
} = constants;

const getNumberOfFilesOptions = () => [
  {
    label: i18next.t('Single file'),
    value: numberOfFilesAttachment.SINGLE,
    isLabelBold: true,
  },
  {
    label: i18next.t('Multi-file upload'),
    value: numberOfFilesAttachment.MULTIPLE,
    isLabelBold: true,
  },
];

const FileFieldControls = ({ control, placeholders, onChangeRequiredFieldControl }) => {
  const validateRequiredField = createRequiredValidator(i18next.t('This field is required'));

  const supportedFileTypes = helpers.getSupportedFileTypes();
  const numberOfFilesOptions = getNumberOfFilesOptions();

  return (
    <Stack gap="spacing-m">
      <ControlGroup title={i18next.t('Label')} required>
        <InputGroupField
          name={fieldControlNames.LABEL}
          control={control}
          placeholder={placeholders[LABEL_INPUT]}
          rules={{
            validate: (value) =>
              validateRequiredField(value) || helpers.validatePersonalData(value),
          }}
        />
      </ControlGroup>
      <ControlGroup title={i18next.t('Button text')} required>
        <InputGroupField
          name={fieldControlNames.BUTTON_TEXT}
          control={control}
          placeholder={placeholders[BUTTON_TEXT_INPUT]}
          rules={{
            validate: (value) =>
              validateRequiredField(value) || helpers.validatePersonalData(value),
          }}
        />
      </ControlGroup>
      <ControlGroup title={i18next.t('Supported file type')}>
        <SimpleSelectField
          name={fieldControlNames.FILE_TYPE}
          control={control}
          options={supportedFileTypes}
        />
      </ControlGroup>
      <ControlGroup title={i18next.t('Allowed number of files')}>
        <RadioButtonGroupField
          name={fieldControlNames.NUMBER_OF_FILES}
          control={control}
          options={numberOfFilesOptions}
        />
      </ControlGroup>
      <CheckboxField
        name={fieldControlNames.REQUIRED}
        control={control}
        label={i18next.t('Make required')}
        onChange={onChangeRequiredFieldControl}
      />
    </Stack>
  );
};

FileFieldControls.propTypes = {
  control: PropTypes.shape({}).isRequired,
  placeholders: PropTypes.shape({
    [LABEL_INPUT]: PropTypes.string,
    [BUTTON_TEXT_INPUT]: PropTypes.string,
  }).isRequired,
  onChangeRequiredFieldControl: PropTypes.func.isRequired,
};

export default FileFieldControls;
